/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Forum, ForumPriv } from '@src/app/model/forum';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { uuid } from '@src/app/model/abstract-object';

@Injectable({
  providedIn: 'root'
})
export class ForumService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);


  protected get baseUrl() {
    return this.getAjaxPath('social/channels');
  }
  protected cache: Forum[];
  protected typeString = 'Forums';

  getPeople(forum: Forum, priv: ForumPriv, areaId: uuid, coreId: uuid, typeId: uuid, categoryId: uuid) {
    const params : Record<string, uuid>= { privilege: priv.id}
    if (areaId) params.areaId = areaId;
    if (coreId) params.coreId = coreId;
    if (typeId) params.typeId = typeId;
    if (categoryId) params.categoryId = categoryId;

    return this.http.get(this.baseUrl + '/' + forum.id + '/people', { params });
  }
}
